import React, { useRef, useEffect } from 'react'

import RepeatOptions from '../RepeatOptions'
import { IMG } from '../../../../themes'

const MonthView = (props) => {
  const {
    isOpen,
    list,
    selectedIndex,
    onDropdown,
    onSelected,
    setIsOpenDropdown,
  } = props

  const selectedBoxStyle = isOpen ? 'selected-active-option' : 'selected-option'
  const wrapperRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onDropdown(false)
        setIsOpenDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onDropdown])

  return (
    <div className='monthly-layout' ref={wrapperRef}>
      <div
        className={selectedBoxStyle}
        onClick={() => onDropdown(!isOpen)}
      >
        <label className='option-text nunito-semibold'>{selectedIndex >= 0 && list[selectedIndex].value}</label>
        <img
          className={!isOpen ? 'arrow-down' : ''}
          src={IMG['chevron_up.svg']}
          alt='arrow'
        />
      </div>
      
      {
        isOpen && (
          <div className='monthly-options'>
            <RepeatOptions
              list={list}
              selectedIndex={selectedIndex}
              onSelected={onSelected}
              isMonthly
            />
          </div>
        )
      }
    </div>
  )
}

export default MonthView
